import { CookieValueTypes, getCookie, setCookie } from "cookies-next";
import { OptionsType } from "cookies-next/lib/types";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

export const useCookieState = <StoredType = CookieValueTypes>(
  cookieName: string,
  initialValue: StoredType | (() => StoredType),
  options?: OptionsType
): [StoredType, Dispatch<SetStateAction<StoredType>>] => {
  const getInitialValue = () => {
    // If we have a value already stored, initialse the state with the value of it.
    const cookieValue = getCookie(cookieName);
    if (cookieValue) {
      return cookieValue as StoredType;
    }

    // If the initial value is a function, call it and return the result.
    if (typeof initialValue === "function") {
      return (initialValue as () => StoredType)();
    }

    // Otherwise, return the initialValue
    return initialValue;
  };

  const [value, setValue] = useState<StoredType>(getInitialValue);

  useEffect(() => {
    // Update the cookie on changes to the state.
    setCookie(cookieName, value, options);
  }, [value]);

  return [value, setValue];
};
